var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextIndent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10a.624.624 0 01-.625.625H8.75a.625.625 0 110-1.25h8.125A.625.625 0 0117.5 10zM8.75 5.625h8.125a.625.625 0 100-1.25H8.75a.625.625 0 000 1.25zm8.125 8.75H3.125a.625.625 0 100 1.25h13.75a.624.624 0 100-1.25zM2.152 11.145a.625.625 0 00.79-.078l3.125-3.125a.625.625 0 000-.884L2.942 3.933a.625.625 0 00-.885.884L4.741 7.5l-2.684 2.683a.625.625 0 00.095.962z"
  })));
}
export default SvgTextIndent;